import axios from "axios";
import moment from "moment";
import {ca} from "vuetify/locale";
const EsecutoriStore={
    state:()=>({
        esecutori:[],
        ambiti:[],
        loaded:false,
        feriePermessiSettimanaInCorso:[],
        feriePermessiSettimanaProssima:[]
    }),
    mutations:{

        feriePermessiLoaded(state, item){
            let feriePermessi=item.feriePermessi;
            let ts=item.ts
            let listaEsFerie=[];
            let listaEsFerieNextWeek=[];
            let giorniFinoAMartedi=getDaysUntilNextTuesday();
            let giorniSettimanaProssima=getDaysFromNextTuesdayToFollowingTuesday();
            let tutteLeFerie=[];
            tutteLeFerie=[...feriePermessi.settimanaInCorso]
            tutteLeFerie=[...tutteLeFerie, ...feriePermessi.settimanaProssima]
            for(let ferie of tutteLeFerie){
                let ore=0;
                if(ferie.type==='DAY'){
                    ore=8;
                }else{
                    ore=parseInt(ferie.value);
                }
                let giorno=ferie.date;
                if(giorniFinoAMartedi.includes(giorno)){
                    let index = -1;
                    if (ferie.user === "silvia.martinello@suite.kumbe.it") {
                        console.log("verifico silvia");
                        index = matchSummary(listaEsFerie, ferie.summary);
                    } else {
                        index=listaEsFerie.findIndex(f=>f.user===ferie.user);
                    }
                    if(index==-1){
                        listaEsFerie.push({
                            days:[giorno],
                            user:ferie.user,
                            ore:ore,
                            summary:ferie.summary
                        })
                    }else{
                        if(!listaEsFerie[index].days.includes(giorno)){
                            listaEsFerie[index].days.push(giorno)
                            listaEsFerie[index].ore+=ore;
                        }
                    }
                }
            }
            for(let ferie of tutteLeFerie){
                let ore=0;
                if(ferie.type==='DAY'){
                    ore=8;
                }else{
                    ore=parseInt(ferie.value);
                }
                let giorno=ferie.date;
                if(giorniSettimanaProssima.includes(giorno)){
                    let index = -1;
                    if (ferie.user === "silvia.martinello@suite.kumbe.it") {
                        console.log("verifico silvia");
                        index = matchSummary(listaEsFerieNextWeek, ferie.summary);
                    } else {
                        index=listaEsFerieNextWeek.findIndex(f=>f.user===ferie.user);
                    }
                    if(index==-1){
                        listaEsFerieNextWeek.push({
                            days:[giorno],
                            user:ferie.user,
                            ore:ore,
                            summary:ferie.summary
                        })
                    }else{
                        if(!listaEsFerieNextWeek[index].days.includes(giorno)){
                            listaEsFerieNextWeek[index].days.push(giorno)
                            listaEsFerieNextWeek[index].ore+=ore;
                        }

                    }
                }
            }
            state.feriePermessiSettimanaInCorso=[...listaEsFerie];
            state.feriePermessiSettimanaProssima=[...listaEsFerieNextWeek];
            this.commit("taskLoadedPM",[...ts]);
        },

        esecutoriLoaded(state, item){
            state.esecutori=[...item.filter(es=>es.email.includes('kumbe.it'))];
            state.loaded=true;
            state.ambiti.push({
                label:'Tutti',
                isExpanded:false,
                esecutori:[]
            })
            state.esecutori.forEach(es=>{
                let ambito={
                    area:'Nessuna',
                }
                if(es.ambiti&&es.ambiti.length>0){
                    //ambito=es.ambiti[0];
                    es.ambiti.forEach(ambit=>{
                        if(ambit.area){
                            let ambitoFind=state.ambiti.find(amb=>amb.label===ambit.area);
                            if(ambitoFind){
                                es.show=true;
                                ambitoFind.esecutori.push({...es})
                            }else{
                                state.ambiti.push({
                                    label:ambit.area,
                                    isExpanded:false,
                                    esecutori:[{...es, show:true}]
                                })
                            }
                        }
                    })
                }

                let ambitoTutti=state.ambiti.find(amb=>amb.label==='Tutti');
                es.show=true;
                if(es.ambiti.some(ambito => ambito.area && ambito.area.trim() !== ''))
                ambitoTutti.esecutori.push({...es})
            });
            let ambitoNessuna=state.ambiti.findIndex(amb=>amb.label==='Nessuna');
            if(ambitoNessuna!==-1){
                let esecutoriNessuna=state.ambiti[ambitoNessuna].esecutori.length;
                if(esecutoriNessuna<=0){
                    state.ambiti.splice(ambitoNessuna, 1)
                }
            }
            return [...item.filter(es=>es.email.includes('kumbe.it'))]
        },
        taskLoadedPM(state, item){
            //let esecutori=[...state.esecutori]
            let ambiti=[...state.ambiti]
            ambiti.forEach(ambito=>{
                ambito.esecutori.forEach(esecutore=>{
                    let taskEsecutore=item.filter(t=> t.idOwner==esecutore.id_account)
                    esecutore.backlogTask=taskEsecutore.filter(t=>t.status==='BACKLOG').length;
                    esecutore.todoTask=taskEsecutore.filter(t=>t.status==='TODO' && t.tag!=='PROGRAMMATO').length;
                    esecutore.reviewTask=taskEsecutore.filter(t=>t.status==='REVIEW').length;
                    esecutore.doneTask=taskEsecutore.filter(t=>t.status==='DONE').length;

                    esecutore.caricoTODO=taskEsecutore.filter(t=>t.status==='TODO' && t.tag!=='PROGRAMMATO').reduce(
                        (accumulator, currentValue) => {
                            if(!isNaN(currentValue.orePreviste))
                                return accumulator + currentValue.orePreviste
                            else
                                return accumulator + 0
                        },
                        0,
                    );

                    let today= new Date();
                    let nextTuesday= moment().add(1, 'day').day(3);

                    esecutore.caricoSettimanaProssimaTodo=taskEsecutore.filter(t=>t.tag==='PROGRAMMATO' && t.startDate===getNextTuesday() && t.status==='TODO').reduce(
                        (accumulator, currentValue) => {

                            if(!isNaN(currentValue.orePreviste))
                                return accumulator + currentValue.orePreviste
                            else
                                return accumulator + 0
                        },
                        0,
                    );
                    esecutore.caricoSettimanaProssimaBacklog=taskEsecutore.filter(t=>t.tag==='PROGRAMMATO' && t.startDate===getNextTuesday() && t.status==='BACKLOG').reduce(
                        (accumulator, currentValue) => {

                            if(!isNaN(currentValue.orePreviste))
                                return accumulator + currentValue.orePreviste
                            else
                                return accumulator + 0
                        },
                        0,
                    );
                    esecutore.taskInProgress=taskEsecutore.filter(t=>t.status==='TODO' && t.tag!=='PROGRAMMATO' && t.startWorkingTS >0).length;
                    esecutore.feedbackStimaWaiting=taskEsecutore.filter(t=>t.status==='TODO' && t.tag!=='PROGRAMMATO' && (t.effortEvaluation !='CONFIRMED'&&t.effortEvaluation !='REFUSED')).length;
                    esecutore.feedbackStimaOK=taskEsecutore.filter(t=>t.status==='TODO' && t.tag!=='PROGRAMMATO' && t.effortEvaluation =='CONFIRMED').length;
                    esecutore.feedbackStimaKO=taskEsecutore.filter(t=>t.status==='TODO' && t.tag!=='PROGRAMMATO' && t.effortEvaluation =='REFUSED').length;
                    esecutore.feedbackEffortRevisionRequested=taskEsecutore.filter(t=>t.status==='TODO' && t.tag!=='PROGRAMMATO' && t.effortRevisionRequestedTS >0).length;


                    if(state.feriePermessiSettimanaInCorso){
                        let index = state.feriePermessiSettimanaInCorso.findIndex(fp=>fp.user !== "silvia.martinello@suite.kumbe.it" && fp.user===esecutore.user);
                        if (index < 0) {
                            index = matchSummary(state.feriePermessiSettimanaInCorso, esecutore.descrizione);
                        }

                        if(index>=0){
                            let oreFerie=state.feriePermessiSettimanaInCorso[index];
                            esecutore.oreFerie=oreFerie;
                        }
                    }
                    if(state.feriePermessiSettimanaProssima){
                        let index= state.feriePermessiSettimanaProssima.findIndex(fp=>fp.user !== "silvia.martinello@suite.kumbe.it" && fp.user===esecutore.user);
                        if (index < 0) {
                            index = matchSummary(state.feriePermessiSettimanaProssima, esecutore.descrizione);
                        }
                        if(index>=0){
                            let oreFerieSettimanaProssima=state.feriePermessiSettimanaProssima[index];
                            esecutore.oreFerieSettimanaProssima=oreFerieSettimanaProssima;
                        }
                    }
                })
            })
            state.ambiti=[...ambiti]
            // esecutori.forEach((esecutore)=>{
            //
            //     let taskEsecutore=item.filter(t=> t.idOwner==esecutore.id_account)
            //     esecutore.backlogTask=taskEsecutore.filter(t=>t.status==='BACKLOG').length;
            //     esecutore.todoTask=taskEsecutore.filter(t=>t.status==='TODO' && t.tag!=='PROGRAMMATO').length;
            //     esecutore.reviewTask=taskEsecutore.filter(t=>t.status==='REVIEW').length;
            //     esecutore.doneTask=taskEsecutore.filter(t=>t.status==='DONE').length;
            //     //TODO: Controllare data inizio/fine task per il calcolo carico ore
            //     esecutore.caricoTODO=taskEsecutore.filter(t=>t.status==='TODO' && t.tag!=='PROGRAMMATO').reduce(
            //         (accumulator, currentValue) => {
            //             if(!isNaN(currentValue.orePreviste))
            //             return accumulator + currentValue.orePreviste
            //             else
            //                 return accumulator + 0
            //         },
            //         0,
            //     );
            // });
            // state.esecutori=[...esecutori];
        },
        startCambiaEsecutore(state, item){
            let esecutoriFilter=[...state.esecutori.filter(es=>es.id_account!=item.idOwner)];
            item.esecutori=esecutoriFilter
            return item
        },
        updateEsecutoriTasks(state, item){
            let esecutori=[...state.esecutori]
            esecutori.forEach((esecutore)=>{

                let taskEsecutore=item.filter(t=> t.idOwner==esecutore.id_account)
                esecutore.backlogTask=taskEsecutore.filter(t=>t.status==='BACKLOG').length;
                esecutore.todoTask=taskEsecutore.filter(t=>t.status==='TODO' && t.tag!=='PROGRAMMATO').length;
                esecutore.reviewTask=taskEsecutore.filter(t=>t.status==='REVIEW').length;
                esecutore.doneTask=taskEsecutore.filter(t=>t.status==='DONE').length;
                //TODO: Controllare data inizio/fine task per il calcolo carico ore
                esecutore.caricoTODO=taskEsecutore.filter(t=>t.status==='TODO' && t.tag!=='PROGRAMMATO').reduce(
                    (accumulator, currentValue) => {
                        if(!isNaN(currentValue.orePreviste))
                            return accumulator + currentValue.orePreviste
                        else
                            return accumulator + 0
                    },
                    0,
                );
            });
            state.esecutori=[...esecutori];
        },
        filtraEsecutori(state, item){
            return item;
        },
        filtraEsecutoriInline(state, item){
            return item;
        },
    },
    actions: {
        async loadEsecutori({commit},filters){
            try{
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                commit("showLoader");
                let request= axios.post(process.env.VUE_APP_TASK_SPRINT_API+ "/quik/getAccounts",{},{...config});
                let response= await request;
                commit("hideLoader");
                if(response.data.responseCode!==200){
                    throw new Error(response.data.dettagli)
                }
                let responseData=JSON.parse(response.data.result);
                let listaEsecutori=responseData.filter(es=>es.email.includes('kumbe.it'))
                commit("esecutoriLoaded", listaEsecutori);
                commit("hideLoader");

            }catch (e){
                commit("hideLoader");
                commit('addMessage', {
                    message:"VUEX loadEsecutori Error: "+e.message,
                    messageType:'error'
                });
            }
        },

        async loadFeriePermessi({commit, getters},filters){
            try{
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                commit("showLoader");
                let request= axios.post(process.env.VUE_APP_TASK_SPRINT_API+ "/kumbeCalendar/getInfo",{},{...config});
                let response= await request;
                commit("hideLoader");
                if(response.data.responseCode!==200){
                    throw new Error(response.data.dettagli)
                }
                let responseData=JSON.parse(response.data.result);
                if(responseData.settimanaInCorso!=='NONE'){
                    responseData.settimanaInCorso=JSON.parse(responseData.settimanaInCorso)
                }
                if(responseData.settimanaProssima!=='NONE'){
                    responseData.settimanaProssima=JSON.parse(responseData.settimanaProssima)
                }
                let ts= getters.getAllTasks();
                let d={
                    ts:ts,
                    feriePermessi:responseData
                }
                commit("feriePermessiLoaded", d);

                commit("hideLoader");

            }catch (e){
                commit("hideLoader");
                commit('addMessage', {
                    message:"VUEX loadEsecutori Error: "+e.message,
                    messageType:'error'
                });
            }
        },
        cambiaEsecutore({commit}, task){
            commit("startCambiaEsecutore", task)
        },
        filtraEsecutori({commit}, idEsecutore){
            commit("filtraEsecutori", idEsecutore)
        },
        filtraEsecutoriInline({commit}, esecutore){
            commit("filtraEsecutoriInline", esecutore)
        },
    },
    getters:{
        getEsecutori: (state) => () => {
            if(!state.loaded){
                return false
            }
            return [...state.esecutori]
        },
        getEsecutoriFilter: (state) => (id) => {
            return [...state.esecutori.filter(es=> es.id_account===id)]
        },
        // getEsecutoriInlineFilter: (state) => (item) => {
        //     return [...state.esecutori.filter(es=> es.user.includes(item.esecutore))]
        // },

        getEsecutoriInlineFilter: (state) => (item) => {
            if(item.esecutore.trim().length===0){
                return [...state.ambiti];
            }
            return [ ...state.ambiti.filter(ambito =>
                ambito.esecutori.some(esecutore => esecutore.descrizione.toLowerCase().includes(item.esecutore.toLowerCase())))
                .map(am => ({
                    ...am, // Mantieni tutte le proprietà dell'ambito
                    esecutori: am.esecutori.filter(es => es.descrizione.toLowerCase().includes(item.esecutore.toLowerCase())) // Filtra gli esecutori
                }))]
        },

        getAmbiti: (state) => () => {
            return [...state.ambiti]
        },
    }
}

export function matchSummary(objects, query) {
    const queryWords = query.toLowerCase().replace("ferie","").replace("permessi","").replace("permesso","").replace("/:","").trim().split(/\s+/);

    return objects.findIndex(obj => {
        const summaryWords = obj.summary.toLowerCase().replace("ferie","").replace("permessi","").replace("permesso","").replace("/:","").split(/\s+/);
        return queryWords.some(word => summaryWords.includes(word));
    });
}
function uuidv4() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
        (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
    );
}

function epochToDate(epoch){
    return moment.unix(1738061999).format("DD/MM/YYYY")
}

function getNextTuesday(){
    let today= moment();
    let weekDay=today.day();
    let daysToAdd=0;

    switch (weekDay){
        case 0:
            daysToAdd=2;
            break;
        case 1:
            daysToAdd=1;
            break;
        case 2:
            daysToAdd=7;
            break;
        case 3:
            daysToAdd=6;
            break;
        case 4:
            daysToAdd=5;
            break;
        case 5:
            daysToAdd=4;
            break;
        case 6:
            daysToAdd=3;
            break;
    }

    let nextTuesday=today.add(daysToAdd, 'day').hours(0).minutes(0).seconds(0).milliseconds(0);
    return nextTuesday.unix()
}

function formatDate(date) {
    return date.toISOString().split('T')[0];
}

function isWeekday(date) {
    const day = date.getDay();
    return day !== 0 && day !== 6; // 0 = Sunday, 6 = Saturday
}

function getDaysUntilNextTuesday() {
    const today = new Date();
    const result = [];
    const day = today.getDay();
    const daysUntilTuesday = (9 - day) % 7 || 7;
    const daysToInclude = daysUntilTuesday - 1;

    for (let i = 0; i <= daysToInclude; i++) {
        const current = new Date(today);
        current.setDate(today.getDate() + i);
        if (isWeekday(current)) {
            result.push(formatDate(current));
        }
    }

    return result;
}

function getDaysFromNextTuesdayToFollowingTuesday() {
    const today = new Date();
    const result = [];
    const day = today.getDay();
    const daysUntilNextTuesday = (9 - day) % 7 || 7;

    const startDate = new Date(today);
    startDate.setDate(today.getDate() + daysUntilNextTuesday); // start from next Tuesday

    for (let i = 0; i < 7; i++) {
        const current = new Date(startDate);
        current.setDate(startDate.getDate() + i);
        if (isWeekday(current)) {
            result.push(formatDate(current));
        }
    }

    return result;
}


export {EsecutoriStore};